export const logLevelToInt = {
  log: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
};
